
import { Mail, Phone } from "lucide-react";

export const OrderSupport = () => {
  return (
    <div className="bg-blue-50 rounded-lg border border-blue-100 p-4 sm:p-6 space-y-3 sm:space-y-4">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Besoin d'aide ?</h2>
      <p className="text-sm sm:text-base text-gray-600">
        Pour toute question concernant votre commande, contactez Steeve Harris :
      </p>
      <div className="space-y-2 sm:space-y-3">
        <a 
          href="mailto:sharris@novationweb.com" 
          className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 bg-white rounded-lg border border-blue-100 hover:border-blue-200 transition-colors"
        >
          <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-blue-500" />
          <span className="text-sm sm:text-base text-gray-700 hover:text-blue-600 break-all">sharris@novationweb.com</span>
        </a>
        <a 
          href="tel:5146059207" 
          className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 bg-white rounded-lg border border-blue-100 hover:border-blue-200 transition-colors"
        >
          <Phone className="w-4 h-4 sm:w-5 sm:h-5 text-blue-500" />
          <span className="text-sm sm:text-base text-gray-700 hover:text-blue-600">514 605 9207</span>
        </a>
      </div>
    </div>
  );
};
